export class UsuarioDTO {
    nombresCompletos:string;
    dni:string;
    userName?:string;
    email?: string;
}